import { initializeApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserSessionPersistence,
  browserLocalPersistence,
  indexedDBLocalPersistence,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const PROD_CONFIG = {
  apiKey: "AIzaSyCHhcur-L5TzPZ_BluF1DM41aa0ZXDXQy8",
  authDomain: "ieum-8fd99.firebaseapp.com",
  projectId: "ieum-8fd99",
  storageBucket: "ieum-8fd99.firebasestorage.app",
  messagingSenderId: "418515339264",
  appId: "1:418515339264:web:225af6472f4b8c02f9f0e5",
  measurementId: "G-51RMRZ89M6",
};

const STAGING_CONFIG = {
  apiKey: "AIzaSyDtRqlMFBoWryG7hCru6dTNq7Vt2qlpjcE",
  authDomain: "test-83e89.firebaseapp.com",
  projectId: "test-83e89",
  storageBucket: "test-83e89.firebasestorage.app",
  messagingSenderId: "468912887921",
  appId: "1:468912887921:web:dc658e0533aedff1dde3d0",
  measurementId: "G-5E3EXG40BE",
};

const ENV = process.env.REACT_APP_ENV;
const firebaseConfig = ENV === 'staging' ? STAGING_CONFIG : PROD_CONFIG;

if (typeof window !== 'undefined') {
  // 환경 식별 — 잘못된 환경에 데이터 쓰는 사고 방지용 콘솔 표시
  // eslint-disable-next-line no-console
  console.log(`[Firebase] env=${ENV === 'staging' ? 'STAGING' : 'PRODUCTION'} project=${firebaseConfig.projectId}`);
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// dev 환경: 탭별 독립 세션 (여러 역할 동시 테스트용)
// production: RN WebView 안정성 위해 indexedDB → localStorage 우선순위로 명시적 fallback
if (process.env.NODE_ENV === 'development') {
  setPersistence(auth, browserSessionPersistence).catch((err) => {
    console.warn('[dev] setPersistence failed', err);
  });
} else {
  // RN WebView 가 IndexedDB 차단할 경우 localStorage 로 폴백
  setPersistence(auth, indexedDBLocalPersistence)
    .catch(() => setPersistence(auth, browserLocalPersistence))
    .catch((err) => console.warn('[auth] setPersistence failed', err));
}

export default app;
